export const GET_REQUESTED_EXTRA_SESSION = 'GET_REQUESTED_EXTRA_SESSION'
export const GET_REQUESTED_EXTRA_SESSION_FAILED = 'GET_REQUESTED_EXTRA_SESSION_FAILED'
export const GET_REQUESTED_EXTRA_SESSION_SUCCESS = 'GET_REQUESTED_EXTRA_SESSION_SUCCESS'

export const UPDATE_REQUESTED_EXTRA_SESSION = 'UPDATE_REQUESTED_EXTRA_SESSION'
export const UPDATE_REQUESTED_EXTRA_SESSION_FAILED = 'UPDATE_REQUESTED_EXTRA_SESSION_FAILED'
export const UPDATE_REQUESTED_EXTRA_SESSION_SUCCESS = 'UPDATE_REQUESTED_EXTRA_SESSION_SUCCESS'

export const CLEAR_REQUESTED_EXTRA_SESSION = 'CLEAR_REQUESTED_EXTRA_SESSION'
